import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    position: 'fixed',
    height: '100%',
    width: '100%',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundImage: 'linear-gradient(180deg, #FFB4AC 0%, #EF6C57 100%)',
    overflow: 'auto',
  },
  formContainer: {
    backgroundColor: '#FFFFFF',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'space-evenly',
    padding: 60,
    width: 560,
    [theme.breakpoints.down('sm')]: {
      width: '100%',
      padding: '60px 20px 60px 20px',
    },
  },
  shape: {
    position: 'absolute',
    height: '100%',
    width: '100%',
    bottom: 0,
  },
  logo: {
    marginBottom: 28,
  },
  title: {
    fontWeight: 600,
    marginBottom: 20,
    fontSize: 20,
  },
  form: {
    display: 'flex',
    flexDirection: 'column',
    [theme.breakpoints.down('sm')]: {
      width: '90%',
    },
  },
  forgotPassword: {
    fontWeight: 'bold',
    textDecoration: 'none',
    margin: '10px 0px 10px 0px ',
  },
  socialIcon: {
    height: 26,
    width: 26,
    margin: theme.spacing(1),
  },
  txRegister: {
    color: theme.palette.primary.main,
    fontWeight: 'bold',
  },
  txNoAccount: {
    color: theme.palette.text.secondary,
    textDecoration: 'none',
    marginTop: theme.spacing(4),
  },
  txFooter: {
    color: theme.palette.text.secondary,
    // position: 'absolute',
    // bottom: 52,
    textAlign: 'center',
  },
}))

export default useStyles
